import React from 'react';
import { HashLink } from 'react-router-hash-link';
import Footer from '../../components/layouts/Footer';
import Navbar from '../../components/layouts/navbar';

const TermsOfUse = () => {
    return (
        <div>
            {/* <Navbar /> */}
            <article class="prose lg:prose-xl mx-auto px-4 lg:px-8 mb-48 mt-8">
                <h2>Terms of Use</h2>
                <p>
                    Welcome to Nuleep, Inc. . We visually reflect the lifestyle
                    and career trends that our job seekers care through a mobile
                    (“APPs”) and web-based platform (“Platform”). We provide
                    vetted referrals and content to recruiters through a mobile
                    (“APPs”) and web-based platform (“Platform”). Please read
                    Nuleep, Inc. ’s Terms of Service (“Terms”) because the Terms
                    govern your usage of the APPs and Platform. The Terms also
                    govern your interaction with Nuleep, Inc. websites and APPs,
                    purchase of any Nuleep, Inc. services or merchandise, and
                    participation in any Nuleep, Inc. live events and
                    promotions.
                </p>
                <p>
                    If you live in the United States, these Terms are entered
                    into between you and Nuleep, Inc. , Inc. for product Nuleep,
                    Inc. , 835 W Warner RD Suite 101 Box 134 Gilbert AZ
                    85233-7273.
                </p>
                <p>
                    Currently Nuleep, Inc. App, Platform, and Services is only
                    provided to residents of the United States.
                </p>
                <p>
                    By using the Services, you are agreeing to these Terms. If
                    you do not agree to these Terms, you may not use the
                    Services. Nuleep, Inc. may modify these Terms at any time,
                    and if we do, we will notify you by posting the modified
                    Terms on the Site or in the App. It’s important that you
                    review any modified Terms before you continue using the
                    Services. If you continue to use the Services, you are bound
                    by the modified Terms. If you don’t agree to be bound by the
                    modified Terms, then you may not use the Services.
                </p>
                <p>
                    Your usage of the Services is also subject to our{' '}
                    <HashLink to="/privacypolicy">Privacy Policy</HashLink>, and
                    our Use of{' '}
                    <HashLink to="/privacypolicy#cookies">
                        Cookies Policy
                    </HashLink>{' '}
                    which covers how we collect, use, share, and store your
                    personal information.
                </p>
                <p>
                    When clicking “Subscribe” “Join Now” “Sign Up” “Login” or
                    similar buttons, registering, using, and accessing the
                    services, you are agreeing to enter into a legally binding
                    contract with Nuleep, Inc. for both personal and
                    professional usage and or capacity. If you do not agree to
                    the Services, do not click “Subscribe” “Join Now” Sign Up”
                    “Login” or similar buttons and do not access or otherwise
                    use any of the Services. If you wish to terminate the
                    Services, at any time you can do so by closing your account
                    and no longer accessing or using the Services.
                </p>

                <h3>Privacy</h3>
                <p>
                    Nuleep, Inc. Services are designed to enable you to interact
                    in our job APPs and Platform that includes your information,
                    data from the real world, and Nuleep, Inc. ’s algorithm. To
                    provide the Services, we need information about you and we
                    only use your information where we have a legal basis to do
                    so. Please review and refer to our{' '}
                    <HashLink to="/privacypolicy">Privacy Policy</HashLink> to
                    help you understand how we collect, use, share, and store
                    your personal information.
                </p>

                <h3>Use of Services</h3>
                <p>
                    Nuleep, Inc. constantly takes into account the importance of
                    security and the importance of providing quality
                    information. Nuleep, Inc. prohibits accessing accounts in an
                    unauthorized manner, falsifying information, and sharing
                    accounts. Nuleep, Inc. also prohibits attempts, altering, or
                    interfering with the normal behavior or rules of Services.
                </p>

                <h3>Safe Usage</h3>
                <p>
                    You shall at all times comply with all applicable laws, and
                    any rules/policies/procedures as provided by Nuleep, Inc. or
                    any authorized third parties. You agree to comply to all
                    policies within the APPs and Site.
                </p>

                <h3>Interactions with Other People</h3>
                <p>
                    You agree to keep your password safe and secure. You agree
                    that in conjunction with your use of the Services, you will
                    maintain safe and appropriate contact with other users,
                    other recruiters, and other people. You will not harass,
                    threaten, or otherwise violate the legal rights of others.
                </p>

                <h3>Eligibility</h3>
                <p>
                    The Services are not for use by anyone under the age of 16
                    (sixteen). You must meet the Minimum Age requirement of 16
                    (sixteen years of age) in order to use the Services, APPs,
                    Platform, and Nuleep, Inc. products. All Services are not
                    for use for anyone under the age of 16 (sixteen).
                </p>
                <p>You agree to the following if you use the Services:</p>
                <ul>
                    <li>
                        You must be of minimum age or older (16 years of age or
                        older).
                    </li>
                    <li>
                        You will have only 1 (one) personal Nuleep, Inc. account
                        which must be in your real name.
                    </li>
                    <li>
                        You are not already restricted by Nuleep, Inc. from
                        using the Services.
                    </li>
                    <li>
                        Creating an account with false information is a
                        violation of our terms including registering accounts on
                        behalf of others.
                    </li>
                    <li>
                        If the law requires that you must be older than the
                        Minimum Age of 16 years old, then, the Minimum age is
                        such older age as set by government/local law.
                    </li>
                </ul>

                <h3>Account Registration</h3>
                <p>
                    To use Services, you will have to create an account with
                    Nuleep, Inc. (an “Account”), and you will also need access
                    to a supported mobile phone, laptop, and an Internet
                    connection/hotspot. Please contact us to check for supported
                    devices. You can create an Account using (a) an email/phone
                    number.
                </p>
                <p>
                    You agree that you won’t disclose your Account password to
                    anyone and that you will notify us immediately of any
                    unauthorized usage of your Account. Nuleep, Inc. takes its
                    account security obligations seriously; however, you are
                    responsible for all activities that occur under your
                    Account, whether or not, you know about them. You agree you
                    are responsible for maintaining the confidentiality of your
                    account and password and for restricting access to your
                    phone, laptop, computer, and other relevant devices, and you
                    agree to accept responsibility for all activities that occur
                    under your account or password. You may not assign or
                    otherwise transfer your account to any other person or
                    entity. You acknowledge that Nuleep, Inc. is not responsible
                    for third party access to your account that results from
                    theft or misappropriation of your account. Nuleep, Inc. and
                    its associates/third party providers reserve the right to
                    refuse or cancel service, terminate accounts, or remove or
                    edit content in our sole discretion.
                </p>
                <p>
                    If the Services is purchased by another party for you to use
                    (ex. Recruiter account by Employer), the party paying for
                    such Service has the right to control access to and get
                    reports on your use of such paid Service; however, they do
                    not have rights to your personal account.
                </p>
                <h3>User Conduct</h3>
                <p>
                    You agree that you are responsible for your own actions and
                    your own conduct and User Content.
                </p>
                <h3>Payment</h3>
                <p>
                    You agree to honor your payment obligations and you agree
                    with us storing your payment information. You understand
                    that there may be fees and taxes that could be added to our
                    prices. Nuleep, Inc. does not guarantee refunds. Please
                    email us at info@Nuleep, Inc. .com for any refund requests.
                    If you buy any of our paid Services (“Premium Services”),
                    you agree to pay us the applicable fees and taxes and to
                    additional terms specific to the paid Services. Failure to
                    pay these fees will result in the termination of your paid
                    Premium Services. Your purchase of Premium Services may be
                    subject to foreign exchange fees or differences in prices
                    based on location. We may store and continue billing your
                    payment method (e.g. credit card/debit card) even after it
                    has expired, to avoid interruptions in your Services and to
                    use to pay for your other Premium Services you may buy.
                </p>
                <p>
                    If you purchase a subscription, your payment method
                    automatically will be charged at the start of each
                    subscription period for the fees and taxes applicable to
                    that period. To avoid future charges, cancel before the
                    renewal date. Contact us at info@Nuleep, Inc. .com to cancel
                    or suspend your Premium Services. It will take 5-7 business
                    days for cancellations. All purchases of Premium Services
                    are subject to Nuleep, Inc. ’s refund policy.
                </p>
                <p>
                    Nuleep, Inc. may calculate applicable taxes payable by you
                    based on the billing information that you provide to us at
                    the time of your purchase of Premium Services.
                </p>
                <p>
                    Invoices and Billing Information will be stored under
                    Billing or Purchase History.
                </p>

                <h3>Messaging and Communication</h3>
                <p>
                    The Services may contain bulletin board services, chat
                    areas, new groups, forums, communities, personal profiles,
                    personal web pages, calendars, and/or other message or
                    communication facilities designed to enable you to
                    communicate with the public at large or with a group or with
                    a recruiter or with another user (collectively,
                    “Communication Services”). You agree to use the
                    Communication Services only to post, send, receive messages
                    and material that are proper and related to particular
                    Communication Service.
                </p>
                <p>
                    By way of example and not as a limitation, you agree that
                    when using a Communication Service, you will not: defame,
                    abuse, harass, stalk, threaten or otherwise violate the
                    legal rights (such as rights of privacy and publicity) of
                    others; publish, post, upload, distribute or disseminate any
                    inappropriate, profane, defamatory, infringing, obscene,
                    indecent or unlawful topic, name material, or information;
                    upload files that contain software or other material
                    protected by intellectual property laws (or by rights of
                    privacy of publicity) unless you own or control the rights
                    thereto or have received all necessary consents; upload
                    files that contain viruses, corrupted files, or any other
                    similar software or programs that may damage the operation
                    of another’s computer; advertise or offer to sell or buy any
                    goods or services for any business purpose, unless
                    Communication Service specifically allows such messages;
                    conduct or forward surveys, contests, pyramid schemes or
                    chain letters; download any file posted by another user of a
                    Communication Service that you know or reasonably should
                    know, cannot be legally distributed in such manner; falsify
                    or delete any author attributions, legal or other proper
                    notices or proprietary designations or labels of the origin
                    or source of software or other material contained in a file
                    that is uploaded; restrict or inhibit any other user from
                    using and enjoying the Communication Services; violate any
                    code of conduct or other guidelines which may be applicable
                    for any particular Communication Service; harvest or
                    otherwise collect information about others, including e-mail
                    addresses, without their consent; violate any applicable
                    laws or regulations.
                </p>
                <p>
                    Nuleep, Inc. has no obligation to monitor the Communication
                    Services. However, Nuleep, Inc. reserves the right to review
                    materials posted to a Communication Services and to remove
                    any materials in its sole discretion. Nuleep, Inc. reserves
                    the right to terminate your access to any or all of the
                    Communication Services at any time without notice for any
                    reason whatsoever.
                </p>
                <p>
                    Nuleep, Inc. reserves the right at all times to disclose any
                    information as necessary to satisfy any applicable law,
                    regulations, legal process, or governmental request, or to
                    edit, refuse to post or to remove any information or
                    materials, in whole or in part, in Nuleep, Inc. ’s sole
                    discretion.
                </p>
                <p>
                    Always use caution when giving out any personally
                    identifying information about yourself or your children in
                    any Communication Service. Nuleep, Inc. does not control or
                    endorse the content, messages or information found in any
                    Communication Service and, therefore, Nuleep, Inc.
                    specifically disclaims any liability with regard to the
                    Communication Services and any actions resulting from your
                    participation in any Communication Service. Managers and
                    hosts are not authorized Nuleep, Inc. spokespersons, and
                    their views do not necessarily reflect those of Nuleep, Inc.
                    .
                </p>
                <p>
                    Materials uploaded to a Communication Service may be subject
                    to posted limitations on usage, reproduction, and/or
                    dissemination. You are responsible for adhering to such
                    limitations if you upload the materials.
                </p>

                <h3>Sharing Materials</h3>
                <p>
                    Nuleep, Inc. does not claim ownership to the materials you
                    provide to Nuleep, Inc. (including feedback and suggestions)
                    or post, upload, input, or submit to any Nuleep, Inc.
                    Services, APPs, websites, and platforms or any associated
                    services or third party provider services (collectively
                    “Submissions”). However, by posting, uploading, inputting,
                    providing, or submitting your Submissions you are granting
                    Nuleep, Inc. , our affiliated companies and necessary
                    sublicensees permission to use your Submission in connection
                    with the operation of their Internet businesses including,
                    without limitation, the rights to: copy, distribute,
                    transmit, publicly display, publicly perform, reproduce,
                    edit, translate and reformat your Submission; and to publish
                    your name in connection with your Submission.
                </p>
                <p>
                    No compensation will be paid with respect to the use of your
                    Submission, as provided here. Nuleep, Inc. is under no
                    obligation to post or use any Submission you may provide and
                    may remove any Submission at any time in Nuleep, Inc. ’s
                    sole discretion.
                </p>
                <p>
                    By posting, uploading, inputting, providing, or submitting
                    your Submission you warrant and represent that you own or
                    otherwise control all of the rights to your Submission as
                    described in this section including, without limitation, all
                    the rights necessary for you to provide, post, upload, input
                    or submit the Submissions.
                </p>
                <p>
                    When you share information on the Services, others can see,
                    copy and use that information and your Submission. Nuleep,
                    Inc. Services allow messaging and sharing of information in
                    many ways such as your profile, resume, photos, and other
                    content. Other users may see or have access to your
                    Submission that you share.
                </p>
                <h3>Licensing</h3>
                <p>
                    All the personal information and content you provide is
                    owned by you. You acknowledge and grant Nuleep, Inc. a
                    non-exclusive license to all the personal information and
                    content you provide. Nuleep, Inc. honors the choices you
                    make about who gets to see your information and content,
                    including how it can be used for ads. You grant us a
                    worldwide, transferable, sublicensable right to use, copy,
                    modify, publish, and distribute all information and content
                    you provide through the Services, third party providers, and
                    without any further consent, notice and/or compensation to
                    you or others.
                </p>
                <p>
                    You agree that if content includes personal data, it is
                    subject to the{' '}
                    <HashLink to="/privacypolicy">Privacy Policy</HashLink>. You
                    agree that Nuleep, Inc. can access, use, store, process,and
                    copy any information and personal data that you provide in
                    accordance with the terms of the{' '}
                    <HashLink to="/privacypolicy">Privacy Policy</HashLink>.
                </p>
                <p>
                    By submitting Feedback to Nuleep, Inc. , you agree and grant
                    Nuleep, Inc. access, use, distribute, and share the feedback
                    you provided for any purpose without compensation to you.
                    Nuleep, Inc. may also choose not to access, use distribute,
                    and share your feedback. You agree to only provide
                    information and content that you have the right to share and
                    that your information and profile will be truthful and
                    accurate. You agree to only provide
                    content/information/feedback that does not violate the law
                    nor anyone’s rights including intellectual property rights.
                    You agree that your profile information and content you
                    provide will be truthful. Nuleep, Inc. may be required by
                    law to remove certain information or content in accordance
                    with legal requirements.
                </p>
                <h3>Service Availability</h3>
                <p>
                    We may change, suspend or end any Service, or change and
                    modify prices prospectively in our discretion. To the extent
                    allowed under law, these changes may be effective upon
                    notice to you. We may change or discontinue any of our
                    Services. We do not promise to store or keep showing any
                    information and/or content that you have posted.
                </p>
                <p>
                    Nuleep, Inc. is not a storage service. You agree that we
                    have no obligation to store, maintain or provide you a copy
                    of any content or information that you or others provide,
                    except to the extent required by applicable law and as noted
                    in our{' '}
                    <HashLink to="/privacypolicy">Privacy Policy</HashLink>.
                </p>
                <h3>
                    Other Content, Services, Apps, Sites. Third Party Providers
                </h3>
                <p>
                    Nuleep, Inc. Services includes third party services and
                    content. Your usage of third party, other content, other
                    services, other apps, other sites, other information posted
                    on the Services is at your own risk. Other content,
                    services, apps, sites, third party providers, and
                    information may offer their own products and services
                    through the Services and Nuleep, Inc. is not responsible for
                    those third-party activities.
                </p>
                <p>
                    Information provided by other content, services, apps,
                    sites, third party providers, and information may have
                    content or information that might be inaccurate, incomplete,
                    misleading, offensive, delayed, illegal, and/or otherwise
                    harmful. Nuleep, Inc. generally does not review content
                    provided by our users and/or by others. You agree that we
                    are not responsible for other’s and users’ content or
                    information. We cannot always prevent this misuse of the
                    Services and you agree that we are not responsible for any
                    type or such of misuses. You acknowledge that the risk that
                    you or your organization may be mistakenly associated with
                    content about others when we allow referrals, connections,
                    and information on the APP and platform.
                </p>
                <p>
                    You are responsible for deciding if you want to access or
                    use third-party apps or sites that link from the Services.
                    If you allow a third party or site to authenticate you or
                    connect with your Nuleep, Inc. account, that app or site can
                    access information on Nuleep, Inc. related to you.
                </p>
                <p>
                    By using the other content, services, apps, sites, third
                    party providers, and information, you acknowledge that
                    Nuleep, Inc. provides these links only as a convenience and
                    is not responsible for the content, products, or services on
                    or available from those websites, resources, links, apps,
                    displayed on such websites or apps. To the extent permitted
                    under applicable law, you acknowledge sole responsibility
                    for and assume all risks arising from, your usage of any
                    other content, services, apps, sites, third party providers,
                    information, and resources.
                </p>
                <p>
                    Other content, other services, other apps, other sites,
                    third party providers, and other information/resources
                    posted on the Services have their own legal terms and
                    privacy policies, and you may be giving others permission to
                    use your information in ways we would not. Except to the
                    limited extent it may be required by applicable law, Nuleep,
                    Inc. is not responsible for these other sites and apps – use
                    these at your own risk. Please see and review our Privacy
                    Policy.
                </p>
                <p>
                    Nuleep, Inc. is not responsible for the availability or
                    quality of third party services, including coaching
                    companies, network speed, delays, and any other services.
                    You hereby waive Nuleep, Inc. and any other party involved
                    in creating or delivering the Services from all claims,
                    demands, cause of action, damages, losses, expenses, act of
                    God, or liability which may arise out of, result from, or
                    relate in any way to such third party services.
                </p>
                <p>
                    MANIPULATING, HACKING, DISRUPTING, INTERFERING AND
                    UNDERMINING THE LEGITIMATE OPERATION OF ANY SITE OR APP, IS
                    A BREACH OF NULEEP, INC.'S TERMS AND MAY BE A BREACH OR
                    VIOLATION OF CRIMINAL AND/OR CIVIL LAWS.
                </p>
                <h3>Limits</h3>
                <p>
                    Nuleep, Inc. has the right to limit how you connect and
                    interact on the Services. Nuleep, Inc. reserves the right to
                    limit your use of the Services and to restrict, suspend,
                    terminate your account if Nuleep, Inc. believes that you may
                    be in breach of the Terms or law or are misusing the
                    Services.
                </p>
                <h3>Intellectual Property</h3>
                <p>
                    You are granted a non-exclusive, non-transferable, revocable
                    license to access and use Nuleep, Inc. strictly in
                    accordance with these terms of use. As a condition of your
                    use of the Services, you warrant to Nuleep, Inc. that you
                    will not use the Services for any purpose that is unlawful
                    or prohibited by these Terms. You may not use the Services
                    in any manner which could damage, disable, overburden, or
                    impair the Site or interfere with any other party’s use and
                    enjoyment of the Site. You may not obtain or attempt to
                    obtain any materials or information through any means not
                    intentionally made available or provided for through the
                    Services.
                </p>
                <p>
                    All content includes as part of the Service, such as text,
                    graphics, logos, images, as well as the compilation thereof,
                    and any software used on the Services, is the property of
                    Nuleep, Inc. or its supplies/third party providers and
                    protected by copyright and other laws that protect
                    intellectual property and proprietary rights. You agree to
                    observe and abide by all copyright and other proprietary
                    notices, legends or other restrictions contained in any such
                    content and will not make any changes thereto.
                </p>
                <p>
                    You will not modify, publish, transmit, reverse engineer,
                    participate in the transfer or sale, create derivative
                    works, or in any way exploit any of the content, in whole or
                    in part, found on the Services, APPs, websites, and
                    platform. Nuleep, Inc. content is not for resale. Your use
                    of the Services does not entitle you to make any
                    unauthorized use of any protected content, and in
                    particular, you will not delete or alter any proprietary
                    rights or attribution notices in any content. You will use
                    protected content solely for your personal use, and will
                    make no other use of the content without the express written
                    permission of Nuleep, Inc. and the copywrite owner. You
                    agree you that you do not acquire any ownership rights in
                    any protected content. We do not grant you any licenses,
                    express or implied, to the intellectual property of Nuleep,
                    Inc. or our licensors except as expressly authorized by
                    these Terms.
                </p>
                <h3>General Terms</h3>
                <p>
                    If a court with authority over this Terms of Service finds
                    any part of it unenforceable, you and Nuleep, Inc. agree
                    that the court should modify the terms to make that part
                    enforceable while still achieving its intent. If the court
                    cannot do that, you and Nuleep, Inc. agree to ask the court
                    to remove the unenforceable part and still enforce the rest
                    of this agreement.
                </p>
                <p>
                    To the extent allowed by the English language version of
                    this Terms of Use agreement (“Agreement”) is binding and
                    other translations are for convenience only. This Agreement
                    including additional terms that may be provided by Premium
                    Services or third party providers is the only agreement
                    between us regarding the Services and supersedes all prior
                    agreements for the Services.
                </p>
                <p>
                    If we don't act to enforce a breach of this Agreement, that
                    does not mean that Nuleep, Inc. has waived its right to
                    enforce this Agreement. You may not assign or transfer this
                    Agreement, your signup or usage of the Services to anyone
                    without our consent. However, you agree that Nuleep, Inc.
                    may assign this Agreement to its affiliates or a party that
                    buys it without your consent. There are no third-party
                    beneficiaries to this Agreement.
                </p>
                <p>
                    You agree that the only way to provide us legal notice is at
                    the address provided in Section 25.
                </p>
                <h3>International Users</h3>
                <p>
                    The Service is controlled, operated, and administered by
                    Nuleep, Inc. from our offices within the USA. If you access
                    the Service from a location outside the USA, you are
                    responsible for compliance with all local laws. You agree
                    that you will not use the Service, APPs, platform, and
                    content accessed through Nuleep, Inc. in any country or in
                    any manner prohibited by any applicable laws, restrictions,
                    or regulations.
                </p>
                <h3>Indemnification</h3>
                <p>
                    You agree to indemnify, defend, and hold harmless Nuleep,
                    Inc. , its officers, directors, employees, agents, and third
                    parties, for any losses, costs, liabilities, and expenses
                    (including reasonable attorney’s fees) relating to or
                    arising out of your use of or inability to use the Site or
                    services, any user postings made by you, your violation of
                    any terms of this Agreement or your violation of any rights
                    of a third party, or your violation of any applicable laws,
                    rules or regulations. Nuleep, Inc. reserves the right, at
                    its own cost, to assume the exclusive defense and control of
                    any matter otherwise subject to indemnification by you, in
                    which event you will fully cooperate with Nuleep, Inc. in
                    asserting any available defenses.
                </p>
                <h3>Arbitration</h3>
                <p>
                    In the event the parties are not able to resolve any dispute
                    between them arising out of or concerning these Terms and
                    Conditions, or any provision hereof, whether in contract,
                    tort, or otherwise at law or in equity for damages or any
                    other relief, then such dispute shall be resolved only by
                    final and binding arbitration pursuant to the Federal
                    Arbitration Act, conducted by a single neutral arbitrator
                    and administered by the American Arbitration Associate, or a
                    similar arbitration service selected by the parties, in a
                    location mutually agreed upon by the parties.
                </p>
                <p>
                    YOU AGREE THAT DISPUTES BETWEEN YOU AND NULEEP, INC. WILL BE
                    RESOLVED BY BINDING, INDIVIDUAL ARBITRATION, AND YOU ARE
                    WAIVING YOUR RIGHT TO A TRIAL BY JURY OR TO PARTICIPATE AS A
                    PLAINTIFF OR CLASS MEMBER IN ANY PURPORTED CLASS ACTION OR
                    REPRESENTATIVE PROCEEDING.
                </p>
                <p>
                    The arbitration will be administered by the American
                    Arbitration Association ("AAA") in accordance with the
                    Commercial Arbitration Rules and the Supplementary
                    Procedures for Consumer-Related Disputes (the “AAA Rules”)
                    then in effect, except as modified by this “Dispute
                    Resolution” section. (The AAA Rules are available at
                    https://www.adr.org/Rules or by calling the AAA at
                    1-800-778-7879.) The Federal Arbitration Act will govern the
                    interpretation and enforcement of this Section.
                </p>
                <h3>Class Action Waiver</h3>
                <p>
                    Any arbitration under these Terms and Conditions will take
                    place on an individual basis; class arbitrations and
                    class/representative/collective actions are not permitted.
                    THE PARTIES AGREE THAT A PARTY MAY BRING CLAIMS AGAINST THE
                    OTHER ONLY IN EACH’S INDIVIDUAL CAPACITY, AND NOT AS A
                    PLAINTIFF OR CLASS MEMBER IN ANY PUNITATIVE CLASS,
                    COLLECTIVE AND/OR REPRESENTATIVE PROCEEDING, SUCH AS IN THE
                    FORM OF A PRIVATE ATTORNEY GENERAL ACTION AGAINST THE OTHER.
                </p>
                <p>
                    Further, unless both you and Nuleep, Inc. agree otherwise,
                    the arbitrator may not consolidate more than one person’s
                    claims, and may not otherwise preside over any form of a
                    representative or class proceeding.
                </p>
                <h3>Liability Disclaimer</h3>
                <p>
                    THE INFORMATION, SOFTWARE, APP, PLATFORM, PRODUCTS, AND
                    SERVICES INCLUDED IN OR AVAILABLE THROUGH THE SERVICES MAY
                    INCLUDE INACCURACIES OR TYPOGRAPHICAL ERRORS. CHANGES ARE
                    PERIODICALLY ADDED TO THE INFORMATION HEREIN. NULEEP, INC.
                    AND/OR ITS SUPPLIERS MAY MAKE IMPROVEMENTS AND/OR CHANGES IN
                    THE SERVICES AT ANY TIME.
                </p>
                <p>
                    NULEEP, INC. AND/OR ITS THIRD PARTY PROVIDERS, AFFILIATES,
                    AND ITS SUPPLIERS MAKE NO REPRESENTATIONS ABOUT THE
                    SUITABILITY, RELIABILITY, AVAILABILITY, TIMELINESS, AND
                    ACCURACY OF THE INFORMATION, SOFTWARE, APP, PLATFORM,
                    PRODUCTS, SERVICES, AND RELATED GRAPHICS CONTAINED ON THE
                    SERVICES FOR ANY PURPOSE. TO THE MAXIMUM EXTENT PERMITTED BY
                    APPLICABLE LAW, ALL SUCH INFORMATION, SOFTWARE, APP,
                    PLATFORM, PRODUCTS, SERVICES, AND RELATED GRAPHICS ARE
                    PROVIDED “AS IS” WITHOUT WARRANTY OR CONDITIONS OF ANY KIND.
                    NULEEP, INC. AND/OR ITS THIRD PARTY PROVIDERS, AFFILIATES,
                    AND SUPPLIERS HEREBY DISCLAIM ALL WARRANTIES AND CONDITIONS
                    WITH REGARD TO THIS INFORMATION, SOFTWARE, APP, PLATFORM,
                    PRODUCTS, SERVICES, AND RELATED GRAPHICS, INCLUDING ALL
                    IMPLIED WARRANTIES OR CONDITIONS OF MERCHANTABILITY, FITNESS
                    FOR A PARTICULAR PURPOSE, TITLE AND NON-INFRINGEMENT.
                </p>
                <p>
                    TO THE MAXIMUM EXTENT PERMITTED BY APPLICABLE LAW, IN NO
                    EVENT SHALL NULEEP, INC. AND/OR ITS THIRD PARTY PROVIDERS,
                    AFFILIATES, AND SUPPLIERS BE LIABLE FOR ANY DIRECT,
                    INDIRECT, PUNITIVE, INCIDENTAL, SPECIAL, CONSEQUENTIAL
                    DAMAGES OR ANY DAMAGES WHATSOEVER INCLUDING, WITHOUT
                    LIMITATION, DAMAGES FOR LOSS OF USE, DATA OR PROFITS,
                    ARISING OUT OF OR IN ANY WAY CONNECTED WITH THE USE OR
                    PERFORMANCE OF THE SERVICES, WITH THE DELAY OR INABILITY TO
                    USE THE SITE OR RELATED SERVICES, THE PROVISION OF OR
                    FAILURE TO PROVIDE SERVICES, OR FOR ANY INFORMATION,
                    SOFTWARE, APP, PLATFORM, PRODUCTS, SERVICES, AND RELATED
                    GRAPHICS OBTAINED THROUGH THE SERVICES, OR OTHERWISE ARISING
                    OUT OF THE USE OF THE SITE, WHETHER BASED ON CONTRACT, TORT,
                    NEGLIGENCE, STRICT LIABILITY OR OTHERWISE, EVEN IF NULEEP,
                    INC. OR ANY OF ITS THIRD PARTY PROVIDERS, AFFILIATES, AND
                    SUPPLIERS HAS BEEN ADVISED OF THE POSSIBILITY OF DAMAGES.
                    BECAUSE SOME STATES/JURISDICTIONS DO NOT ALLOW THE EXCLUSION
                    OR LIMITATION OF LIABILITY FOR CONSEQUENTIAL OR INCIDENTAL
                    DAMAGES, THE ABOVE LIMITATION MAY NOT APPLY TO YOU. IF YOU
                    ARE DISSATISFIED WITH ANY PORTION OF THE SERVICES, OR WITH
                    ANY OF THESE TERMS OF USE, YOUR SOLE AND EXCLUSIVE REMEDY IS
                    TO DISCONTINUE USING THE SITE.
                </p>
                <h3>Changes to Terms</h3>
                <p>
                    Nuleep, Inc. reserves the right, in its sole discretion, to
                    change the Terms under which Nuleep, Inc. is offered. The
                    most current version of the Terms will supersede all
                    previous versions. Nuleep, Inc. encourages you to
                    periodically review the Terms to stay informed of our
                    updates.
                </p>
                <h3>Complaints and Questions</h3>
                <p>
                    For complaints and questions, please refer to Contact
                    Information below. Nuleep, Inc. respects the intellectual
                    property rights of others. We require information provided
                    and posted by our users to be accurate and not in violation
                    of intellectual property rights or rights of third parties.
                </p>
                <h3>Contact Information</h3>
                <p>
                    If you have any questions or want to provide feedback,
                    please email Nuleep, Inc. at info@Nuleep, Inc. .com or 1812
                    Burbank Blvd. #7216 Burbank, California 91506
                </p>
            </article>
            {/* <Footer /> */}
        </div>
    );
};

export default TermsOfUse;
